<footer>
  <span>&#169; DIGITALLANDSOLUTIONS LTD</span>
  <a href="https://help.thelandapp.com">Help</a>
  <a href="https://help.thelandapp.com/en/collections/192411-legal">Legal</a>
</footer>
